
import {
  defineComponent,
} from 'vue';
import { useDriveStore } from '../modules/drive/store/driveStore';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  props: ['onDelete'],
  emits: ['close'],
  setup() {
    const mainStore = useMainStore();
    const driveStore = useDriveStore();

    return {
      mainStore,
      driveStore,
    };
  },
});
